import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center page-main-title" }
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = { class: "col-md-9 col-lg-10 px-md-4" }
const _hoisted_7 = { class: "container py-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-center text-lg-start py-3" }
const _hoisted_10 = { class: "hc3 bold" }
const _hoisted_11 = { class: "container pt-5" }
const _hoisted_12 = { class: "row tut-ul" }
const _hoisted_13 = { class: "col-12 col-lg-4 pb-2 text-center text-lg-start" }
const _hoisted_14 = {
  href: "/tutorials/windows?p=2",
  target: "_blank"
}
const _hoisted_15 = { class: "col-12 col-lg-4 pb-2 text-center text-lg-start" }
const _hoisted_16 = {
  href: "/tutorials/android?p=2",
  target: "_blank"
}
const _hoisted_17 = { class: "col-12 col-lg-4 pb-2 text-center text-lg-start" }
const _hoisted_18 = {
  href: "/tutorials/ios?p=2",
  target: "_blank"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-sand my-3" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 text-center text-lg-start py-3" }
const _hoisted_22 = { class: "hc3 bold" }
const _hoisted_23 = { class: "container pt-5" }
const _hoisted_24 = { class: "row tut-ul" }
const _hoisted_25 = { class: "col-12 col-lg-4 pb-2 text-center text-lg-start" }
const _hoisted_26 = {
  href: "/tutorials/windows11?p=2",
  target: "_blank"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-sand my-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.locale.windows10), 1)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.locale.tutorials1), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", _hoisted_14, _toDisplayString($setup.locale.windows11), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", _hoisted_16, _toDisplayString($setup.locale.android11), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", _hoisted_18, _toDisplayString($setup.locale.ios11), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_19
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString($setup.locale.tutorials2), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", _hoisted_26, _toDisplayString($setup.locale.windows11_1), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_27
            ])
          ])
        ])
      ])
    ])
  ]))
}